import { core, dateUtil } from '@/core'
import Basic from '@basic'

const util = {
  template: {
    table(opt, tar) {
      const td = '<td><div><a class="cell"></a></div></td>'
      const tr = `<tr>${Array(4).fill(td).join('')}</tr>`
      const table = $(`
      <table class="month-table"  style="display:none;">
        <tbody>${Array(3).fill(tr).join('')}</tbody>
      </table>`)
      const months = opt.months
      Array.from(table.find('.cell')).map((node, i) => {
        $(node).text(months[i])
      })
      return table
    }
  },
  updater: {
    // 基本属性: date
    date(value, opt, tar, node) {
      const cells = tar.unit.find('.cell')
      Array.from(cells).map((item, i) => {
        const td = $(item).closest('td')
        const column = td[0].cellIndex
        const row = td[0].parentNode.rowIndex
        const month = row * 4 + column
        const [year] = dateUtil.getDateArr(value)
        // 增加已选中的标识
        const [y, m] = dateUtil.getDateArr(value)
        if (year === y && month === m) td.addClass('current')
        else td.removeClass('current')
        // 增加今日标识
        const [yy, mm] = dateUtil.getDateArr(new Date())
        if (year === yy && month === mm) td.addClass('today')
        else td.removeClass('today')
      })
    },
    // 基本功能: 是否显示
    show(value, opt, tar, node) {
      if (value) {
        tar.unit.show()
      } else {
        tar.unit.hide()
      }
      tar.shown()
    },
    // 基本功能: 月份表
    months(value, opt, tar, node) {
      if (value.length !== 12) {
        Array.from(tar.unit.find('.cell')).map((node, i) => {
          $(node).text(value[i])
        })
      }
    }
  }
}

export default class MonthTable extends Basic {
  constructor(opt) {
    super(opt)
    this.defaults = {
      date: new Date(), // 基本功能: 设置时间
      show: false, // 基本功能: 显示/隐藏
      months: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'], // 基本功能: 月份表
      max: {}, // 基本功能: 最大时间
      min: {} // 基本功能: 最小时间
    }
    this.events = {
      click: 'onClick',
      shown: null
    }
    core.proxyApi(this) // 核心属性处理
    core.proxyEvent(this) // 核心事件处理
    this.settings = Object.assign({}, this.defaults, opt)
    this.init()
  }

  init () {
    const opt = this.settings
    const template = util.template.table(opt, this)
    const members = {}
    core.compileSymbol(template[0], members)
    this.members = members
    this.unit = template
    core.update(util.updater, opt, this)
    this.bindInput()
  }

  bindInput() {
    this.unit.click($.proxy(this.click, this))
  }

  getMonthOfCell(month) {
    const year = this.date.getFullYear()
    return new Date(year, month, 1)
  }

  onClick(event) {
    let target = event.target
    if (target.tagName === 'A') {
      target = target.parentNode.parentNode
    }
    if (target.tagName === 'DIV') {
      target = target.parentNode
    }
    if (target.tagName !== 'TD') return false
    if ($(target).hasClass('disabled')) return false
    const column = target.cellIndex
    const row = target.parentNode.rowIndex
    const month = row * 4 + column
    const newDate = this.getMonthOfCell(month)
    let value
    if (this.selectionMode === 'range') {
      if (!this.rangeState.selecting) {
        value = { minDate: newDate, maxDate: null }
        this.rangeState.selecting = true
      } else {
        if (newDate >= this.minDate) {
          value = { minDate: this.minDate, maxDate: newDate }
        } else {
          value = { minDate: newDate, maxDate: this.minDate }
        }
        this.rangeState.selecting = false
      }
    } else {
      value = month
    }
    return value
  }
}
